module.exports = __webpack_public_path__ + "img/logo-encuesta.259dbdd9.png";